import { StatusCreate } from '../components/Status/StatusCreate';
import { StatusList } from '../components/Status/StatusList';
import { StatusEdit } from '../components/Status/StatusEdit';

export const Statuses = {
  list: StatusList,
  create: StatusCreate,
  edit: StatusEdit
};